import React, { useEffect, useState } from "react";
import { Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import Select from "react-select";
import {
  get_Company_Transaction,
  get_Single_CompanyTransaction,
  get_Dropdown_Transaction_Category,
  get_Company_Header_Transaction,
} from "../../../store/actions/CommanAction";
import Loader from "../Loader/Loader";

const CompanyTransaction = () => {
  const dispatch = useDispatch();
  const CompanyTransaction = useSelector(
    (state) => state.feedBackReducer.CompanyTransaction
  );
 
  const headercompanyTransaction = useSelector(
    (state) => state.feedBackReducer.HeaderCompanyTransaction
  );

  useEffect(() => {
    dispatch(get_Dropdown_Transaction_Category());
  }, [dispatch]);

  const SingleTransaction = useSelector(
    (state) => state.feedBackReducer.CompanyTransactionSingle
  );

  const TransactionDropdownCategory = useSelector(
    (state) => state.feedBackReducer.TransactionDropCategory
  );

  const customerID = Number(sessionStorage.getItem("ID"));

  const [IsActive, setIsActive] = useState(true);
  const [postModal, setPostModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editModal2, setEditModal2] = useState(false);
  const [EditValue, setEditValue] = useState("");
  const [ExpenseCategoryID, setExpenseCategoryID] = useState("");
  const [loading, setloading] = useState(false);

  const [addFormData, setaddFormData] = useState({
    Category: "",
    TransactionType: "",
    CategoryId: "",
    description: "",
    Amount: "",
    comment: "",
    Date: "",
    Nextrenewedate: "",
    // CreatedByUser: "1",
    IsActive: "1",
  });

  const [startTime, setStartTime] = useState("");

  const [endTime, setEndTime] = useState("");

  const [orderStatus, setOrderStatus] = useState();
  const [transactionData, setTransactionData] = useState([]);



  const Reset = () => {
    setaddFormData({
      ...addFormData,
      Category: "",
      TransactionType: "",
      CategoryId: "",
      description: "",
      Amount: "",
      comment: "",
      Date: "",
    });
  };

  useEffect(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const formattedToday = `${yyyy}-${mm}-${dd}`;

    const defaultStartTime = `${formattedToday}`;
    const defaultEndTime = `${formattedToday}`;

    setStartTime(defaultStartTime);
    setEndTime(defaultEndTime);


    dispatch(
      get_Company_Transaction(
        setloading,
        IsActive,
        formattedToday,
        formattedToday,
        orderStatus
      )
    );
    dispatch(
      get_Company_Header_Transaction(IsActive, formattedToday, formattedToday)
    );

  }, [dispatch]);

  useEffect(() => {
    if (SingleTransaction) {
      setEditValue(SingleTransaction);
    }
  }, [SingleTransaction]);



  useEffect(() => {
    if (EditValue && EditValue.length > 0) {
      const formatToDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
          2,
          "0"
        )}-${String(date.getDate()).padStart(2, "0")}`;
      };

      setaddFormData({
        ...addFormData,
        ExpenseCategoryID: ExpenseCategoryID,
        Category: EditValue[0]?.TransactionCategory,
        Amount: EditValue[0]?.Amt,
        Date: formatToDate(EditValue[0]?.TransactionDateTime),

        TransactionType: EditValue[0]?.TransactionType,
        CategoryId: EditValue[0]?.TransactionCategoryID,
        description: EditValue[0]?.Description,

        comment: EditValue[0]?.Comments,
      });
    }
  }, [EditValue]);

  const handleAddFormSubmit = async (event) => {
    event.preventDefault();
    let error = false;
    let errorMsg = "";

    const trimmedTransactionType = addFormData.TransactionType.trim();
    const trimmedCategory = addFormData.Category?.trim() || "";
    const trimmedAmount = addFormData.Amount?.trim() || "";

    if (!trimmedCategory) {
      error = true;
      errorMsg = "Please fill Transaction Category.";
    }
    if (!trimmedAmount) {


      error = true;
      errorMsg = "Please fill Transaction Amount.";
    }

    if (!trimmedTransactionType) {
      error = true;
      errorMsg = "Please fill Transaction Type.";
    }

    if (!error) {
      const newCustomerStory = {
        TransactionCategory: addFormData.Category,
        TransactionCategoryID: addFormData.CategoryId,
        TransactionType: addFormData.TransactionType,
        IsActive: addFormData.IsActive,
        Amt: addFormData.Amount,
        Comments: addFormData.comment,
        Description: addFormData.description,
        TransactionDateTime: addFormData.Date,
        CreatedByUser: customerID,
      };

      await AddUpdate(
        "CompanyTransaction/Insert_CompanyTransaction",
        newCustomerStory
      );
      setPostModal(false);
      dispatch(get_Company_Transaction(setloading, IsActive));
      swal("Good job!", "Successfully Added", "success");
      Reset();
      setaddFormData({
        Category: "",
        TransactionType: "",
        CategoryId: "",
        description: "",
        Amount: "",
        comment: "",
        Date: "",
        Nextrenewedate: "",
        IsActive: "1",
      });
    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  const UpdateSlider = async (event) => {
    event.preventDefault();
    let error = false;
    let errorMsg = "";

    const trimmedTransactionType = addFormData.TransactionType.trim();
    const trimmedCategory = addFormData.Category?.trim() || "";
    const trimmedAmount = addFormData.Amount || "";

    if (!trimmedTransactionType) {
      error = true;
      errorMsg = "Please fill Transaction Type.";
    }

    if (!trimmedCategory) {
      error = true;
      errorMsg = "Please fill Transaction Category.";
    }
    if (!trimmedAmount) {
      error = true;
      errorMsg = "Please fill Transaction Amount.";
    }
    if (!error) {
      const newCustomerStory = {
        Id: ExpenseCategoryID,
        TransactionCategory: addFormData.Category,
        TransactionCategoryID: addFormData.CategoryId,
        TransactionType: addFormData.TransactionType,
        IsActive: addFormData.IsActive,
        Amt: addFormData.Amount,
        Comments: addFormData.comment,
        Description: addFormData.description,
        TransactionDateTime: addFormData.Date,
        CreatedByUser: customerID,
      };
      await AddUpdate(
        "CompanyTransaction/Update_CompanyTransaction",
        newCustomerStory
      );
      setEditModal(false);
      dispatch(get_Company_Transaction(setloading, IsActive));
      swal("Good job!", "Successfully update", "success");
      Reset();
      setaddFormData({
        Category: "",
        TransactionType: "",
        CategoryId: "",
        description: "",
        Amount: "",
        comment: "",
        Date: "",
      });
    } else {
      swal("Oops", errorMsg, "error");
    }
  };


  const handleAddFormChange = (e) => {
    const { name, value } = e.target;

    setaddFormData((prevData) => {
      let updatedValue = value.replace(/[+-]/g, "");

      if (name === "Amount") {
        if (prevData?.TransactionType === "Payment") {
          updatedValue = `-${updatedValue}`;
        }
        return { ...prevData, [name]: updatedValue };
      }

      return { ...prevData, [name]: value };
    });
  };

  const handleEditClick = (row) => {
    dispatch(get_Single_CompanyTransaction(row?.ID));
    setExpenseCategoryID(row?.ID);
    setEditModal(true);
  };
  const handleEditClick2 = (row) => {
    dispatch(get_Single_CompanyTransaction(row?.ID));
    setEditModal2(true);
  };

  const handleSearch = async () => {
    const formatDate = (dateTime) => {
      if (!dateTime) return null;
      const date = new Date(dateTime);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };

    const formattedStartDate = formatDate(startTime);
    const formattedEndDate = formatDate(endTime);

    const data = {
      IsActive: IsActive,
      TransactionDateFrom: formattedStartDate,
      TransactionDateTo: formattedEndDate,
      TransactionType: orderStatus,
    };

    try {
      const transactionResponse = await dispatch(
        get_Company_Transaction(
          setloading,
          IsActive,
          data.TransactionDateFrom,
          data.TransactionDateTo,
          data.TransactionType
        )
      );

      if (
        CompanyTransaction &&
        Array.isArray(CompanyTransaction) &&
        CompanyTransaction.length > 0
      ) {
        setTransactionData(CompanyTransaction);


      } else {
        setTransactionData([]);

      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (CompanyTransaction?.length > 0) {
      dispatch(get_Company_Header_Transaction(IsActive, startTime, endTime));
    }
  }, [CompanyTransaction, IsActive, startTime, endTime]);

  const columns = [
 {
      name: "Name",
      selector: (row) => row.NickName,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div >
          <div>
            {row.NickName}({row.UserID})
          </div>
          
        </div>
      ),
    },

    {
      name: "Payment Category",
      selector: (row) => row.TransactionCategory,
      sortable: true,
    },
    {
      name: "Payment Type",
      selector: (row) => row.TransactionType,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row.Amt,
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => row.Description,
      sortable: true,
    },
    {
      name: "Comment",
      selector: (row) => row.Comments,
      sortable: true,
    },

    {
      name: "Date",
      selector: (row) => row.TransactionDateTime?.slice(0, 10),
      sortable: true,
    },

    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p> 
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown>
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
              <Dropdown.Item onClick={() => handleEditClick(row)}>
                Edit
              </Dropdown.Item>
              
              <Dropdown.Item onClick={() => handleEditClick2(row)}>
                Show Description
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];


  const columns1 = [
   
    {
      name: "Payment Category",
      selector: (row) => row.TransactionCategory,
      sortable: true,
    },
    {
      name: "Payment Type",
      selector: (row) => row.TransactionType,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row.Amt,
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => row.Description,
      sortable: true,
    },
    {
      name: "Comment",
      selector: (row) => row.Comments,
      sortable: true,
    },

    {
      name: "Date",
      selector: (row) => row.TransactionDateTime,
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 0 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <>
          <div style={{ position: "absolute", top: 4, right: 5 }}>
            <Dropdown>
              <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                <Dropdown.Item
                  className={row.IsActive ? "text-danger" : "text-success"}
                  onClick={() => {
                    handleToggleStatusClick(row.ID, false, "1");
                  }}
                >
                  Active
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      ),
    },
  ];

  const handleToggleStatusClick = async (
    ExpenseCategoryID,
    currentStatus,
    isActiveValue
  ) => {
    const postData = {
      ID: ExpenseCategoryID,
      DeleteByUser: customerID,
      IsActive: isActiveValue,
    };
    await AddUpdate("CompanyTransaction/Delete_CompanyTransaction", postData);
    dispatch(get_Company_Transaction(setloading, currentStatus ? "1" : "0"));
    swal(
      "Good job!",
      `Successfully ${isActiveValue === "1" ? "Active" : "Inactive"}`,
      "success"
    );
  };


  return (
    <>
      <Tab.Container defaultActiveKey="All">

        <div className="main_card">
          <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Transaction</h2>
          <div className="row mt-3 align-items-end">
            <div className="col-3">
              <div className="form-group">
                <label className="form-label">Start Time</label>
                <input
                  type="date"
                  // className="form-control"
                  value={startTime}
                  onChange={(e) => setStartTime(e.target.value)}
                />
              </div>
            </div>
            <div className="col-3">
              <div className="form-group">
                <label className="form-label">End Time</label>
                <input
                  type="date"
                  // className="form-control"
                  value={endTime}
                  onChange={(e) => setEndTime(e.target.value)}
                />
              </div>
            </div>

            <div style={{ justifyContent: "end" }} className="col-6 d-flex ">
              <Link
                to={"#"}
                className="btn btn-primary font-w600 text-center"
                onClick={() => {
                  setPostModal(true);
                  Reset();
                }}
              >
                + New Transaction Details
              </Link>
            </div>
          </div>

          <div className="d-flex align-items-center mt-3">
            <label
              style={{
                marginRight: "10px",
                color: "black",
                fontSize: "15px",
                fontStyle: "bold",
              }}
            >
              Payment Type:
            </label>
            <div className="d-flex">
              <label style={{
                display: "flex",
                alignItems: "center",
                gap: "8px", // spacing between radio and text
                marginRight: "10px",
                color: "black",

              }}>
                <input
                  type="radio"
                  name="orderStatus"
                  value="complete"
                  checked={orderStatus === "Receive"}
                  onChange={() => setOrderStatus("Receive")}
                />
                Receive
              </label>
              <label style={{
                display: "flex",
                alignItems: "center",
                gap: "8px", // spacing between radio and text
                marginRight: "10px",
                color: "black",

              }}>
                <input
                  type="radio"
                  name="orderStatus"
                  value="pending"
                  checked={orderStatus === "Payment"}
                  onChange={() => setOrderStatus("Payment")}
                />
                Payment
              </label>
              <label style={{
                display: "flex",
                alignItems: "center",
                gap: "8px", // spacing between radio and text
                marginRight: "10px",
                color: "black",

              }}>
                <input
                  type="radio"
                  name="orderStatus"
                  value="all"
                  checked={orderStatus === null}
                  onChange={() => setOrderStatus(null)}
                />
                All
              </label>
            </div>
            <button
              style={{ marginLeft: "30px" }}
              className="btn btn-primary"
              onClick={() => handleSearch()}
            >
              Search
            </button>
          </div>
        </div>
        <div className="row main_card pt-0">
          <div className="col-xl-12">
            <div className="">
              <div className=" p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All">
                    <div className="mb-sm-5 d-flex flex-wrap align-items-center text-head">
                      <Modal
                        className="modal fade"
                        show={postModal}
                        onHide={() => setPostModal(false)}
                        backdrop="static"
                      >
                        <form>
                          <div className="modal-header">
                            <h4 className="modal-title fs-20">
                              Add Transaction Details
                            </h4>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => setPostModal(false)}
                              data-dismiss="modal"
                            ></button>
                          </div>
                          <div className="modal-body p-3">
                            <i
                              className="flaticon-cancel-12 close"
                              data-dismiss="modal"
                            ></i>
                            <div className="add-contact-box">
                              <div className="add-contact-content">
                                <div className="form-group">
                                  <div style={{ display: "flex", alignItems: "center", }}>
                                    <label htmlFor="">Category</label>
                                    <span className="text-danger star-error" style={{ marginTop: "-5px" }}>
                                      *
                                    </span>
                                  </div>
                                  <select

                                    name="Category"
                                    value={addFormData.CategoryId}
                                    onChange={(e) => {
                                      const selectedOption =
                                        e.target.options[e.target.selectedIndex];
                                      setaddFormData((prevState) => ({
                                        ...prevState,
                                        Category:
                                          selectedOption.getAttribute(
                                            "data-label"
                                          ),
                                        CategoryId: selectedOption.value,
                                      }));
                                    }}
                                  >
                                    <option value="" disabled>
                                      Select a category
                                    </option>
                                    {TransactionDropdownCategory?.map(
                                      (category, index) => (
                                        <option
                                          key={index}
                                          value={category.value}
                                          data-label={category.label}
                                        >
                                          {category.label}
                                        </option>
                                      )
                                    )}
                                  </select>
                                </div>
                              </div>

                              <div className="add-contact-content">
                                <div className="form-group">
                                  <div style={{ display: "flex", alignItems: "center", }}>
                                    <label htmlFor="transaction">
                                      Transaction Type
                                    </label>
                                    <span className="text-danger star-error" style={{ marginTop: "-5px" }}>
                                      *
                                    </span>
                                  </div>
                                  <Select
                                    name="TransactionType"
                                    value={
                                      [
                                        { value: "Payment", label: "Payment" },
                                        { value: "Receive", label: "Receive" },
                                      ].find(
                                        (obj) =>
                                          obj.value ===
                                          addFormData?.TransactionType
                                      ) || null
                                    }
                                    options={[
                                      { value: "Payment", label: "Payment" },
                                      { value: "Receive", label: "Receive" },
                                    ]}
                                    onChange={(selectedOption) =>
                                      handleAddFormChange({
                                        target: {
                                          name: "TransactionType",
                                          value: selectedOption?.value || "",
                                        },
                                      })
                                    }
                                    placeholder="Select Transaction..."
                                    isClearable={true}
                                    classNamePrefix="form-select"
                                    required
                                    styles={customStyles}
                                  />
                                </div>
                              </div>

                              <div className="add-contact-content">
                                <div className="form-group">
                                  <label htmlFor="">Description</label>
                                  <input
                                    type="text"
                                    // className="form-control"
                                    autoComplete="off"
                                    name="description"
                                    required="required"
                                    value={addFormData?.description}
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>

                              <div className="add-contact-content">
                                <div className="form-group">
                                  <div style={{ display: "flex", alignItems: "center", }}>
                                    <label htmlFor="">Transaction Amount</label>
                                    <span className="text-danger star-error" style={{ marginTop: "-5px" }}>
                                      *
                                    </span>
                                  </div>
                                 

                                  <input
                                    type="number"
                                    // className="form-control"
                                    autoComplete="off"
                                    name="Amount"
                                    required="required"
                                    value={
                                      addFormData?.TransactionType === "Receive"
                                        ? `${addFormData?.Amount || ""}`
                                        : addFormData?.TransactionType ===
                                          "Payment"
                                          ? `${addFormData?.Amount || ""}`
                                          : addFormData?.Amount || ""
                                    }
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>

                              <div className="add-contact-content">
                                <div className="form-group">
                                  <label htmlFor="">Comment</label>

                                  <input
                                    type="text"
                                    // className="form-control"
                                    autoComplete="off"
                                    name="comment"
                                    required="required"
                                    value={addFormData?.comment}
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>

                              <div className="add-contact-content">
                                <div className="form-group">
                                  <label htmlFor=""> Date</label>

                                  <input
                                    type="date"
                                    // className="form-control"
                                    autoComplete="off"
                                    name="Date"
                                    required="required"
                                    value={addFormData?.Date}
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={handleAddFormSubmit}
                            >
                              Save
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                setPostModal(false);
                                Reset();
                              }}
                              className="btn btn-danger"
                            >
                              <i className="flaticon-delete-1"></i> Close
                            </button>
                          </div>
                        </form>
                      </Modal>
                    </div>

                    <Modal
                      className="modal fade "
                      show={editModal}
                      onHide={setEditModal}
                      backdrop="static"
                    >
                      <div className="" role="document">
                        <div className="">
                          <form>
                            <div className="modal-header">
                              <h4 className="modal-title fs-20">
                                Edit TransactionDetails
                              </h4>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setEditModal(false)}
                                data-dismiss="modal"
                              ></button>
                            </div>
                            <div className="modal-body p-3">
                              <i
                                className="flaticon-cancel-12 close"
                                data-dismiss="modal"
                              ></i>
                              <div className="add-contact-box">
                                <div className="add-contact-content">
                                  <div className="form-group">
                                    <div style={{ display: "flex", alignItems: "center", }}>
                                      <label htmlFor="">Category</label>
                                      <span className="text-danger star-error" style={{ marginTop: "-5px" }}>
                                        *
                                      </span>
                                    </div>
                                    <select
                                      name="Category"
                                      value={addFormData.CategoryId}
                                      onChange={(e) => {
                                        const selectedOption =
                                          e.target.options[
                                          e.target.selectedIndex
                                          ];
                                        setaddFormData((prevState) => ({
                                          ...prevState,
                                          Category:
                                            selectedOption.getAttribute(
                                              "data-label"
                                            ),
                                          CategoryId: selectedOption.value,
                                        }));
                                      }}
                                    >
                                      <option value="" disabled>
                                        Select a category
                                      </option>
                                      {TransactionDropdownCategory?.map(
                                        (category, index) => (
                                          <option
                                            key={index}
                                            value={category.value}
                                            data-label={category.label}
                                          >
                                            {category.label}
                                          </option>
                                        )
                                      )}
                                    </select>
                                  </div>
                                </div>

                                <div className="add-contact-content">
                                  <div className="form-group">
                                    <div style={{ display: "flex", alignItems: "center", }}>
                                      <label htmlFor="transaction">
                                        Transaction Type
                                      </label>
                                      <span className="text-danger star-error" style={{ marginTop: "-5px" }}>
                                        *
                                      </span>
                                    </div>
                                    <Select
                                      name="TransactionType"
                                      value={
                                        [
                                          { value: "Payment", label: "Payment" },
                                          { value: "Receive", label: "Receive" },
                                        ].find(
                                          (obj) =>
                                            obj.value ===
                                            addFormData?.TransactionType
                                        ) || null
                                      }
                                      options={[
                                        { value: "Payment", label: "Payment" },
                                        { value: "Receive", label: "Receive" },
                                      ]}
                                      onChange={(selectedOption) =>
                                        handleAddFormChange({
                                          target: {
                                            name: "TransactionType",
                                            value: selectedOption?.value || "",
                                          },
                                        })
                                      }
                                      placeholder="Select Transaction..."
                                      isClearable={true}
                                      classNamePrefix="form-select"
                                      required
                                      styles={customStyles}
                                    />
                                  </div>
                                </div>


                                <div className="add-contact-content">
                                  <div className="form-group">
                                    <label htmlFor="">Description</label>

                                    <input
                                      type="text"
                                      // className="form-control"
                                      autoComplete="off"
                                      name="description"
                                      required="required"
                                      value={addFormData?.description}
                                      onChange={handleAddFormChange}
                                    />
                                  </div>
                                </div>

                                <div className="add-contact-content">
                                  <div className="form-group">
                                    <div style={{ display: "flex", alignItems: "center", }}>
                                      <label htmlFor="">Transaction Amount</label>
                                      <span className="text-danger star-error" style={{ marginTop: "-5px" }}>
                                        *
                                      </span>
                                    </div>
                                    <input
                                      type="number"
                                      // className="form-control"
                                      autoComplete="off"
                                      name="Amount"
                                      required="required"
                                      value={
                                        addFormData?.TransactionType === "Receive"
                                          ? `${addFormData?.Amount || ""}`
                                          : addFormData?.TransactionType ===
                                            "Payment"
                                            ? `${addFormData?.Amount || ""}`
                                            : addFormData?.Amount || ""
                                      }
                                      onChange={handleAddFormChange}
                                    />

                                  </div>
                                </div>

                                <div className="add-contact-content">
                                  <div className="form-group">
                                    <label htmlFor="">Comment</label>

                                    <input
                                      type="text"
                                      // className="form-control"
                                      autoComplete="off"
                                      name="comment"
                                      required="required"
                                      value={addFormData?.comment}
                                      onChange={handleAddFormChange}
                                    />
                                  </div>
                                </div>

                                <div className="add-contact-content">
                                  <div className="form-group">
                                    <label htmlFor=""> Date</label>
                                    <input
                                      type="date"
                                      // className="form-control"
                                      autoComplete="off"
                                      name="Date"
                                      required="required"
                                      value={addFormData?.Date}
                                      onChange={handleAddFormChange}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={UpdateSlider}
                              >
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setEditModal(false);
                                  Reset();
                                }}
                                className="btn btn-danger"
                              >
                                {" "}
                                <i className="flaticon-delete-1"></i> Close
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </Modal>

                    <Modal
                      className="modal fade "
                      show={editModal2}
                      onHide={setEditModal2}
                      backdrop="static"
                    >
                      <div className="" role="document">
                        <div className="">
                          <form>
                            <div className="modal-header">
                              <h4 className="modal-title fs-20">
                                Full Description
                              </h4>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setEditModal2(false)}
                                data-dismiss="modal"
                              ></button>
                            </div>
                            <div className="modal-body p-3">
                              <i
                                className="flaticon-cancel-12 close"
                                data-dismiss="modal"
                              ></i>
                              <div className="add-contact-box">
                                <div className="add-contact-content">
                                  <label htmlFor="">Description</label>

                                  <input
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    name="description"
                                    required="required"
                                    value={addFormData?.description}
                                    readOnly
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                onClick={() => {
                                  setEditModal2(false);
                                  Reset();
                                }}
                                className="btn btn-danger"
                              >
                                {" "}
                                <i className="flaticon-delete-1"></i> Close
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </Modal>


                    {CompanyTransaction?.length > 0 &&
                      headercompanyTransaction?.map((item) => (
                        <span
                          style={{
                            color: "black",
                            fontSize: "15px",
                            margin: "20px",
                            fontWeight: "bold",
                          }}
                          key={item.id}
                        >
                          Total {item.TransactionCategory}: {item.Amount}
                        </span>
                      ))}

                    <div className="col-12 mt-2">
                      {loading ? (
                        <Loader />
                      ) : (
                        <DataTable
                          dense
                          data={CompanyTransaction}
                          columns={columns}
                          selectableRowsHighlight
                          pagination
                          persistTableHead={true}
                          noDataComponent={"There are no data to display"}
                          customStyles={customStyles}
                        />
                      )}
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="Inactive">
                    <div className="row">
                      <div className="col-12 mt-2">
                        {loading ? (
                          <Loader />
                        ) : (
                          <DataTable
                            dense
                            data={CompanyTransaction}  
                            columns={columns1}
                            selectableRowsHighlight  
                            highlightOnHover
                            pagination
                            customStyles={customStyles}
                            fixedHeader
                            persistTableHead={true}
                            noDataComponent={"There are no data to display"}
                          />
                        )}
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
    </>
  );
};
export default CompanyTransaction;
